import { Directive, Input } from '@angular/core';
import { WhitelabelImage, WhitelabelImageType } from '../../models/general/whitelabel-image.enum';

@Directive()
export class WhitelabelImageBaseComponent {
  @Input() whitelabelImage: WhitelabelImage;
  @Input() whitelabelImageType: WhitelabelImageType = WhitelabelImageType.PNG; //default
  @Input() onSurface = false;
  imageSource = '';
}
